module.exports = __webpack_public_path__ + "img/one-line.0f4546c1.svg";